import { z } from 'zod';

export const ChangeOperationSchema = z.enum(['INSERT', 'UPDATE', 'DELETE']);
export type ChangeOperation = z.infer<typeof ChangeOperationSchema>;

export const ChangeJournalEntrySchema = z.object({
  id: z.string().uuid(),
  sequenceNumber: z.number().int().positive(),
  entityType: z.string().min(1),
  entityId: z.string().uuid(),
  operation: ChangeOperationSchema,
  patch: z.string(), // Serialized JSON string of changed fields
  lamportTimestamp: z.number().int().nonnegative(),
  timestamp: z.string().datetime(),
  originDeviceId: z.string(),
});
export type ChangeJournalEntry = z.infer<typeof ChangeJournalEntrySchema>;

export const SyncCheckpointSchema = z.object({
  remoteDeviceId: z.string(),
  lastAcknowledgedSequence: z.number().int().nonnegative(),
  remoteLamportTimestamp: z.number().int().nonnegative(),
  lastSyncAt: z.string().datetime(),
});
export type SyncCheckpoint = z.infer<typeof SyncCheckpointSchema>;

export const ConflictRecordSchema = z.object({
  id: z.string().uuid(),
  entityType: z.string(),
  entityId: z.string().uuid(),
  fieldName: z.string(),
  localValue: z.string().nullable(),
  remoteValue: z.string().nullable(),
  resolvedValue: z.string().nullable(),
  strategy: z.enum(['AUTO_LWW', 'MANUAL']),
  resolvedAt: z.string().datetime(),
});
export type ConflictRecord = z.infer<typeof ConflictRecordSchema>;

export const BackupManifestSchema = z.object({
  backupFormatVersion: z.number().int().default(1),
  schemaVersion: z.number().int().default(1),
  appVersion: z.string(),
  exportedAt: z.string().datetime(),
  originDeviceId: z.string(),
  checksumSHA256: z.string(),
  checksumAlgorithm: z.string().optional(),
  entityCounts: z.record(z.number().int().nonnegative()),
});
export type BackupManifest = z.infer<typeof BackupManifestSchema>;
